import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import "LIBS/jquery.showhtml.js";

// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.EmailSurveyModal
*
* Encapsulates the functionality of a modal dialog that contains thank you for signing up information.
**/
HSN.EmailSurveyModal = (function (parent) {
    __extends(EmailSurveyModal, parent);

    /**
    * new HSN.EmailSurveyModal()
    **/
    function EmailSurveyModal() {
        this.name = 'HSN.EmailSurveyModal';

        var modal = EmailSurveyModal.__super__.constructor.call(this);

        eventHandlers(this);

        return modal;
    }

    /**
    * HSN.EmailSurveyModal#Show(email) -> void
    * Display the modal and load in the information
    **/
    EmailSurveyModal.prototype._show = function (url) {
        var scope = this;
        $.ajax(url, {   
            dataType: 'html',
            success: function (data) {
                scope.Root.removeClass('loading');
                scope.DisplayModal(data, 0);
            },
            error: function () {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    function eventHandlers(modal) {
            
        $(modal.Content).on('click', '#confirm-cancel', function (e) {
            e.stopPropagation();
            e.preventDefault();

            $(modal.Close).click();
        });
    }

    EmailSurveyModal.prototype.DisplayModal = function (data, time) {
        var scope = this;

        this.Content.showHtml(data, time,
            function () {
                scope.Center();
                scope.Content.animate({ opacity: 1 });

            },
            function () {
                //scope.Center();
            });

    };

    return EmailSurveyModal;

})(HSN.Modal);




// WEBPACK FOOTER //
// ./assets/js/HSN/EmailSurveyModal.js